import { AlertTriangle, Eye, FileClock, Fingerprint, LifeBuoy, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTASection, PageHero, PrototypeNotice, SectionIntro } from '../components/Sections';
import { safetyItems } from '../data';

export function Safety() {
  return (
    <>
      <PageHero
        eyebrow="Safety centre"
        title="Trust should be visible at every step."
        text="Sawwari’s safety experience brings account protection, reviewed information, journey records and support direction into one clear public reference."
        tone="ink"
      >
        <div className="button-row">
          <Link className="button button--light" to="#safety-foundations">See safety foundations</Link>
          <Link className="button button--ghost-light" to="/support">Get support</Link>
        </div>
      </PageHero>

      <section className="section" id="safety-foundations">
        <div className="container">
          <SectionIntro
            eyebrow="Safety foundations"
            title="Designed for prevention, visibility and response."
            text="These sections avoid absolute guarantees and explain the controls the platform is designed to support."
          />
          <div className="safety-grid">
            {safetyItems.map((item, index) => {
              const icons = [Fingerprint, Eye, FileClock, LifeBuoy];
              const Icon = icons[index];
              return <article key={item.title}><span><Icon /></span><h3>{item.title}</h3><p>{item.text}</p></article>;
            })}
          </div>
        </div>
      </section>

      <section className="section section--soft">
        <div className="container incident-grid">
          <div className="incident-card incident-card--emergency">
            <span><AlertTriangle /></span>
            <small>Immediate danger</small>
            <h2>Contact emergency services first.</h2>
            <p>If someone is in immediate danger in Pakistan, call Police Emergency 15. Platform support is not a substitute for emergency services.</p>
            <a className="button button--danger" href="tel:15">Call 15</a>
          </div>
          <div className="incident-card">
            <span><ShieldCheck /></span>
            <small>After the immediate risk</small>
            <h2>Create a traceable support record.</h2>
            <p>Use the support flow to preserve the issue, related journey details and future responses under one immutable ticket reference.</p>
            <Link className="button button--secondary" to="/support">Open support</Link>
          </div>
        </div>
        <div className="container"><PrototypeNotice>Emergency integrations, live sharing, response coverage and escalation wording require final operational testing before launch.</PrototypeNotice></div>
      </section>

      <CTASection
        title="Clear safety information builds better decisions."
        text="Keep this centre updated as live product controls, emergency integrations and support coverage are confirmed."
        primary={{ label: 'Get support', to: '/support' }}
        secondary={{ label: 'Explore services', to: '/services' }}
      />
    </>
  );
}
